import { combineReducers } from "redux";
import authReducer from "./authReducer";
import homeReducer from "./homeReducer";
import detailReducer from "./detailReducer";
import signUpReducer from "./signUpReducer";
import tierReducer from "./tierReducer";
import seeAllReducer from "./seeAllReducer";
import searchReducer from "./searchReducer";
import eventReducer from "./eventReducer";
import loaderReducer from "./loaderReducer";
import companyPageReducer from "./companyPageReducer";
import expertPageReducer from "./expertPageReducer";
import seriesPageReducer from "./seriesPageReducer";
import forYouPageReducer from "./forYouPageReducer";
import languageReducer from "./languageReducer";

export default combineReducers({
  auth: authReducer,
  home: homeReducer,
  detail: detailReducer,
  signup: signUpReducer,
  tier: tierReducer,
  seeAll: seeAllReducer,
  search: searchReducer,
  eventDetails: eventReducer,
  loader: loaderReducer,
  companyPage: companyPageReducer,
  expertPage: expertPageReducer,
  seriesPage: seriesPageReducer,
  forYouPage: forYouPageReducer,
  language: languageReducer,
});
